module.exports = __webpack_public_path__ + "img/BR.89c647bf.webp";